var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.984 18.75a1.58 1.58 0 0 1-1.161-.48 1.58 1.58 0 0 1-.48-1.16h1.641v1.64Zm-1.64-3.281v-1.64h1.64v1.64h-1.64Zm0-3.281v-1.641h1.64v1.64h-1.64Zm0-3.282v-1.64h1.64v1.64h-1.64Zm0-3.281c0-.456.16-.843.479-1.162a1.58 1.58 0 0 1 1.161-.479v1.641h-1.64ZM5.625 18.75v-1.64h1.64v1.64h-1.64Zm1.64-3.281a1.58 1.58 0 0 1-1.16-.48 1.58 1.58 0 0 1-.48-1.16V2.89c0-.456.16-.843.48-1.162a1.58 1.58 0 0 1 1.16-.479h8.75c.456 0 .844.16 1.162.48.32.318.48.705.48 1.16v10.938c0 .456-.16.843-.48 1.162a1.58 1.58 0 0 1-1.161.479h-8.75Zm0-1.64h8.75V2.89h-8.75v10.937Zm1.641 4.921v-1.64h1.64v1.64h-1.64Zm3.281 0v-1.64h1.641c0 .455-.16.842-.479 1.16a1.58 1.58 0 0 1-1.162.48Z",
    fill: "#697094"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9069b03f.svg";
export { ForwardRef as ReactComponent };